import axios from 'axios';
import { useSessionStore } from '@/stores/session';

const axiosInstance = axios.create({
    timeout: 30000
});

axiosInstance.interceptors.request.use(async function (axiosConfig: any) {
    const sessionStore = useSessionStore();

    if (sessionStore.sid === undefined || sessionStore.sid === '') {
        await sessionStore.createSID();
        axiosConfig.headers['SID'] = sessionStore.sid;
    } else {
        axiosConfig.headers['SID'] = sessionStore.sid;
    }

    return axiosConfig;
});

export default axiosInstance
